export default {
  'site.name': 'AllChinaBuy Spreadsheet',
  'site.tagline': 'Your Smarter Way to Explore AllChinaBuy',
  'site.description': 'Explore the AllChinaBuy spreadsheet with product lists, seller guides, QC tips, shipping information, reviews and buying resources.',
  'nav.home': 'Home',
  'nav.spreadsheet': 'Spreadsheet',
  'nav.guides': 'Guides',
  'nav.products': 'Products',
  'nav.sellers': 'Sellers',
  'nav.shipping': 'Shipping',
  'nav.qc': 'QC',
  'nav.review': 'Review',
  'nav.safety': 'Safety',
  'nav.articles': 'Articles',
  'nav.language': 'Language',
  'nav.mainSite': 'Main Website',
  'nav.shoppingGuide': 'Shopping Guide',
  'hero.title': 'AllChinaBuy Spreadsheet: Find Products, Sellers & Buying Guides',
  'hero.subtitle': 'Discover organized AllChinaBuy spreadsheet resources, product guides, seller information, QC tips, shipping guides and practical buying advice in one place.',
  'hero.cta.explore': 'Explore AllChinaBuy Spreadsheet',
  'hero.cta.guides': 'Browse Buying Guides',
  'hero.cta.mainSite': 'Visit Main Website',
  'hero.search.placeholder': 'Search AllChinaBuy spreadsheet, products, sellers or guides...',
  'categories.title': 'Popular Categories',
  'categories.subtitle': 'Browse our curated product categories from the AllChinaBuy spreadsheet',
  'categories.all': 'All Categories',
  'features.title': 'Why Use AllChinaBuy Spreadsheet',
  'features.organized': 'Organized Products',
  'features.organized.desc': 'All products neatly categorized and searchable for easy discovery.',
  'features.sellers': 'Verified Sellers',
  'features.sellers.desc': 'Find reliable sellers with ratings and product quality information.',
  'features.qc': 'QC Guidance',
  'features.qc.desc': 'Learn quality control tips to ensure you get exactly what you ordered.',
  'features.shipping': 'Shipping Info',
  'features.shipping.desc': 'Compare shipping methods, costs, and delivery times to your country.',
  'articles.title': 'Latest Guides & Articles',
  'articles.subtitle': 'In-depth resources to help you shop smarter on AllChinaBuy',
  'articles.readMore': 'Read More',
  'articles.allArticles': 'View All Articles',
  'products.title': 'Featured Products',
  'products.subtitle': 'Browse curated products from the AllChinaBuy spreadsheet. Click any item to jump to the product page and complete your purchase.',
  'products.viewAll': 'View All',
  'products.buy': 'Buy',
  'products.viewFull': 'View Full Spreadsheet',
  'products.wantMore': 'Want to see more products?',
  'products.moreDesc': 'Explore the full AllChinaBuy spreadsheet with 10,000+ verified products across all categories.',
  'products.visitFull': 'Visit Full Spreadsheet',
  'cta.title': 'Ready to Start Shopping?',
  'cta.subtitle': 'Visit our main website to browse the full AllChinaBuy spreadsheet and start your shopping journey.',
  'cta.button.main': 'AllChinaBuy Spreadsheet',
  'cta.button.buy': 'Buy It Now',
  'footer.about': 'About',
  'footer.contact': 'Contact',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Service',
  'footer.disclaimer': 'Disclaimer',
  'footer.editorial': 'Editorial Policy',
  'footer.copyright': 'AllChinaBuy Spreadsheet. Independent resource hub. Not affiliated with AllChinaBuy.',
  'footer.disclaimerText': 'This website is an independent informational resource and is not affiliated with or officially endorsed by AllChinaBuy unless explicitly stated.',
  'lang.en': 'English',
  'lang.fr': 'French',
  'lang.da': 'Danish',
  'lang.de': 'German',
  'seo.homeTitle': 'AllChinaBuy Spreadsheet – Products, Sellers & Buying Guides',
  'seo.homeDescription': 'Explore the AllChinaBuy spreadsheet with product lists, seller guides, QC tips, shipping information, reviews and buying resources.',
};